<template>
  <div>
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-12">
            <div class="form-group">
                <component-input
                    placeholder="Введите заголовок"
                    v-model="currFilters.name"
                    label="Заголовок"/>
            </div>
          </div>
          <label class="control-label">Дата публикации c</label>
          <div class="col-12">
            <div class="form-group form-group-date">
                <date-component
                    v-model="currFilters.publicationDateFrom"/>
            </div>
          </div>
          <label class="control-label">по</label>
          <div class="col-12">
            <div class="form-group form-group-date">
                <date-component
                    v-model="currFilters.publicationDateTo"/>
            </div>
          </div>
          <div class="col-12">
            <div class="form-group">
                <component-input
                    placeholder="Введите текст анонса"
                    v-model="currFilters.previewText"
                    label="Анонс"/>
            </div>
          </div> 
          <div class="col-12">
            <div class="form-group">
                <component-input
                    placeholder="Выберите статус"
                    v-model="currFilters.newsStatus"
                    type="select2"
                    :select2Options="newsStatuses" 
                    :select2Settings="select2Settings"
                    label="Статус новости"/>
            </div>
          </div>         
        </div>
      </div>
      <div class="card-footer d-flex">
        <button-component @click="apply">Применить</button-component>
        <button-component kind="secondary" @click="reset">Сбросить</button-component>
      </div>
    </div>
  </div>
</template>

<script>
import ButtonComponent from "@/common/ui/ButtonComponent";
import ComponentInput from "@/common/components/ComponentInput";
import DateComponent from "@/common/components/DateComponent";

export default {
  name: "NewsPublicFilter",
  components: {ComponentInput, ButtonComponent, DateComponent},
  props: {
    filters: Object
  },
  data() {
    return {
      currFilters: this.filters, 
      newsStatuses: [
        { id: 2, text: "Опубликованные" },
        { id: 3, text: "Архивные" }
      ], 
      select2Settings: {
        language: 'ru',
        allowClear: false
      },    
    };
  },
  created() {
    if (!this.currFilters.newsStatus)
      this.currFilters.newsStatus = 2;
  },
  methods: {
    apply() {
      const filters = Object.assign({}, this.currFilters);
      this.$emit('apply', filters);
    },
    reset() {
      this.currFilters = {
        name: '',
        publicationDateFrom: null,
        publicationDateTo: null,
        previewText: ''
      };
      const filters = Object.assign({}, this.currFilters);
      this.$emit('reset', filters);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "src/assets/theme/default/colors";
.form-group{
    label {
        font-weight: 400 !important;
        color: $gray-dark;
        font-size: 16px;
    }
}

.card-footer{
  gap:16px;
  align-items: center;
  justify-content: space-between;
}

.form-group-date::v-deep {
  .v3dp__popout {
    position: fixed !important;
  }
}
</style>